import { PREFIX_DEFAULT } from '../helpers/tablePrefixes'

export default {
  methods: {
    /**
     * Set columns visible value from localStorage.
     * If LocalStorage hashes is empty, then build it before.
     *
     * @returns {Array} columns array with setted visible value.
     */
    setColVisible() {
      try {
        if (!this.sourceColumns.length) return

        if (!this.colHashes().get()) {
          this.colHashes().buildAndSet()
        }

        return this.mergeColsVisible()
      } catch (error) {
        console.error(new Error(error))

        return this.setVisibleDefault()
      }
    },

    colHashes() {
      const vm = this
      const TableLSId = PREFIX_DEFAULT + vm.storageId

      return {
        /**
         * Set column visible hashes to LocalStorage.
         *
         * @param hashes {Object} Column visible hashes object. Eg. => { id: true, date: false }
         */
        set(hashes) {
          return vm.$ls.set(TableLSId, hashes)
        },

        /**
         * @return {Object} Columns visible hashes from LocalStorage. Eg. => { id: true, date: false }
         */
        get() {
          return vm.$ls.get(TableLSId)
        },

        /**
         *
         * Build column object hashes.
         * Building it from vm.columns if it exists, else build from vm.sourceColumns.
         *
         * @returns {Object} Returns builded column object hashes.
         */
        build() {
          try {
            const hashObject = {}
            const localColumns = vm.columns.length ? vm.columns : vm.sourceColumns

            localColumns.forEach((column) => {
              hashObject[column.field] = column.visible ?? true
            })

            return hashObject
          } catch (error) {
            throw new Error('Build columns hashes was failed.')
          }
        },

        /**
         * Build column hash object and then set it to LocalStorage.
         */
        buildAndSet() {
          const hashes = this.build()

          return this.set(hashes)
        },
      }
    },

    /**
     * Merge source columns visibe value with columns hashes from LocalStorage.
     * Then filter undefined array items who haven't `title` or `field` in his object.
     *
     * This list uses in settings modal.
     *
     * @returns {Array} table columns with setted visible value from LocalStorage columns hashes.
     */
    mergeColsVisible() {
      const storageColumns = this.colHashes().get()

      return this.sourceColumns
        .map((col) => {
          if (!col.field) return
          if (!col.title) return

          return {
            ...col,
            visible: storageColumns[col.field] ?? true,
          }
        })
        .filter((col) => col)
    },

    /**
     * @return {Array} Returns filtered columns where `visible` = true.
     */
    getVisbleColumns(columns) {
      if (columns.length <= 0) return []

      return columns.filter((col) => col.visible)
    },

    /**
     * Set default visible value = true
     * Method uses in catch cases.
     */
    setVisibleDefault() {
      if (!this.sourceColumns.length) return []

      return this.sourceColumns
        .map((col) => {
          if (!col.field) return
          if (!col.title) return

          return {
            ...col,
            visible: true,
          }
        })
        .filter((col) => col)
    },

    /**
     * Filter only columns which can change visible state.
     */
    allowChangeVisible(columns) {
      return columns.filter((col) => !col.disallowChangeVisible)
    },
  },
}
